import Tab from '@/components/Tab'
import TabHeader from '@/components/TabHeader'
import Slider from '@/components/Slider'
import Corridor from '@/layouts/Corridor'

export default {
	props: {
		value: Number,
		height: Number,
		open: Boolean
	},
	methods: {
		toggle() {
			this.$emit('toggle')
		}
	},
	components: {
		Tab,
		TabHeader,
		Slider,
		Corridor
	}
}
